import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export interface ProfileState {
  maxId: number | null;
  firstName: string;
  lastName: string;
  avatar: string | null;
  onboardingCompleted: boolean;
}

interface ProfileActions {
  setProfile: (data: {
    maxId: number;
    firstName: string;
    lastName?: string;
    avatar?: string;
  }) => void;
  setOnboardingCompleted: (completed: boolean) => void;
  reset: () => void;
}

const initialState: ProfileState = {
  maxId: null,
  firstName: "",
  lastName: "",
  avatar: null,
  onboardingCompleted: false,
};

export const useProfileStore = create<ProfileState & ProfileActions>()(
  persist(
    (set) => ({
      ...initialState,

      setProfile: (data) => {
        set({
          maxId: data.maxId,
          firstName: data.firstName,
          lastName: data.lastName || "",
          avatar: data.avatar || null,
        });
      },

      setOnboardingCompleted: (completed: boolean) => {
        set({ onboardingCompleted: completed });
      },

      reset: () => {
        set({ ...initialState });
      },
    }),
    {
      name: "cryptcloud-profile-storage",
      partialize: (state) => ({
        maxId: state.maxId,
        firstName: state.firstName,
        lastName: state.lastName,
        avatar: state.avatar,
        onboardingCompleted: state.onboardingCompleted,
      }),
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
